import {
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from "@chakra-ui/react";
import { LanguageIcon } from "@root/assets/icons";
import { EngIcon } from "@root/assets/icons/engIcon";
import { StyledResLaguageContainer } from "@root/components/dashboard/sidebar/style";
import { StyledSelect } from "@root/components/styled-select";
import { LANGUAGE, LANGUAGES } from "@root/constants";
import useCustomTheme from "@root/hooks/useCustomTheme";
import useLanguage from "@root/hooks/useLanguage";

export const LanguageNav = ({ isOpen }: any) => {
  const { currentLanguage, handleUpdateLanguage } = useLanguage();
  const { isDarkTheme } = useCustomTheme();
  const selectedLanguage = { value: "English", label: "English" };
  const systemLaguages = [
    {
      title: "English",
      onClick: () => handleUpdateLanguage(LANGUAGE.ENGLISH),
      isActive: currentLanguage === LANGUAGE.ENGLISH,
    },
    {
      title: "Korean",
      onClick: () => handleUpdateLanguage(LANGUAGE.KOREAN),
      isActive: currentLanguage === LANGUAGE.KOREAN,
    },
  ];

  return (
    <Box>
      {isOpen && (
        <StyledSelect
          keys={["code", "name"]}
          menuPlacement="top"
          options={LANGUAGES as TObject[]}
          value={selectedLanguage}
        />
      )}
      {!isOpen && (
        <Menu placement="right-start">
          <MenuButton cursor={"pointer"} as={Box}>
            <StyledResLaguageContainer
              border={"1px solid"}
              borderColor={isDarkTheme ? "theme.gray.200" : "theme.gray.100"}
            >
              {currentLanguage === "EN" ? <EngIcon /> : <LanguageIcon />}
            </StyledResLaguageContainer>
          </MenuButton>
          <Portal>
            <MenuList
              gap={0}
              px={"6px"}
              boxShadow={"0px 0px 10px 0px rgba(0, 0 ,0 ,0.1)"}
              width={"fit-content"}
              mr={"0px"}
              className="left-box"
            >
              {systemLaguages.map((menu: any, index: number) => {
                return (
                  <Box key={index}>
                    <MenuItem
                      borderRadius={"8px"}
                      onClick={() => {
                        menu?.onClick();
                      }}
                      key={index}
                      _hover={{
                        bg: "theme.alert.200",
                        color: "theme.button.primary",
                      }}
                      bgColor={
                        menu?.isActive ? "theme.alert.200" : "transparent"
                      }
                      color={
                        menu?.isActive
                          ? "theme.button.primary"
                          : "theme.gray.400"
                      }
                      icon={menu?.icon}
                      height={"55px"}
                    >
                      {menu?.title}
                    </MenuItem>
                  </Box>
                );
              })}
            </MenuList>
          </Portal>
        </Menu>
      )}
    </Box>
  );
};
